import { Modal } from "rsuite"

const TokensExpiredModal = ({ setReauthenticateModal, reauthenticateModal, reauthenticateHandler,emailsToReauthenticate }) => {
    return (
        <Modal
            backdrop={true}
            className=""
            onHide={() => { setReauthenticateModal(false) }}
            show={reauthenticateModal} 
            size="sm"
        >
            <Modal.Header>
                <h3 className="mb-0 fw-bold">Tokens Expired</h3>
            </Modal.Header>
            <Modal.Body className='p-0'>
                <h4 className='p-0'>Your tokens are expired for <span className='fw-bold'>{emailsToReauthenticate}</span></h4>
                <p className='fs-4 p-0'>Please re-authenticate again</p>
            </Modal.Body>
            <Modal.Footer >
                <button className='report_button_secondary' onClick={reauthenticateHandler}>OK</button>
            </Modal.Footer>
        </Modal>
    )
}

export default TokensExpiredModal